import React from "react";

export const reasons = [
  { id: 0, name: 'All', value: '' },
  { id: 1, name: 'Sale', value: 'Sale' },
  { id: 2, name: 'Lost', value: 'Lost' },
  { id: 3, name: 'Others', value: 'Others' },
  { id: 4, name: 'OnHold', value: 'OnHold' },
  { id: 5, name: 'Transfer', value: 'Transfer' },
  { id: 6, name: 'Addition', value: 'Addition' },
  { id: 7, name: 'Purchased', value: 'Purchased' },
  { id: 8, name: 'Destroyed', value: 'Destroyed' },
  { id: 9, name: 'Bulk To Unit', value: 'BulkToUnit' },
  { id: 10, name: 'Other Reduction', value: 'OtherReduction' },
  { id: 11, name: 'Returned From Customer', value: 'ReturnedFromCustomer' },
  { id: 12, name: 'Returned To Distributor', value: 'ReturnedToDistributor' },
  { id: 13, name: 'Transfer Between Branches', value: 'TransferBetweenBranches' },
  { id: 14, name: 'InSufficient LotNumber Switch', value: 'InSufficientLotNumberSwitch' },
  { id: 15, name: 'Receive Transfer From Another Branch', value: 'ReceiveTransferFromAnotherBranch' }
];

export const typeOptions = [
  { text: "All", value: "all" },
  { text: "Cannabis", value: true },
  { text: "Non-Cannabis", value: false }
]

export const columnOptions = [
  {
    text: "Image", value: "imageURL", width: '100px', headerClassName: '', rowClassName: 'imageCell', rowValue: (product, img) => (
      <img
        src={img}
        alt={product.productName}
        onError={(event) => event.target.style.display = 'none'}
        height="50px"
      />
    ), order: 1
  },
  { text: "Product Name", value: "productName", width: '300px', headerClassName: 'left-align-text', rowClassName: 'purpText left-align-text', order: 2 },
  { text: "SKU", value: "sku", width: '200px', headerClassName: 'left-align-text', rowClassName: 'left-align-text', order: 3 },
  { text: "Category", value: "categoryName", width: '200px', headerClassName: 'left-align-text', rowClassName: 'left-align-text', order: 4 },
  { text: "Brand", value: "brand", width: '200px', headerClassName: 'left-align-text', rowClassName: 'left-align-text', order: 5 }];

export const itemsPerPageOptions = [{ text: "20 per page", value: 20 }, { text: "50 per page", value: 50 }, { text: "100 per page", value: 100 }];

export const showStockOptions = [{ text: "Only In-Stock", value: "inStock" }, { text: "All", value: "allStock" }];
